import { GlobalVariables } from "../GlobalVariables";
import { gsap, ScrollTrigger } from "../LibrariesImport";

export default class BlockIntroHome {
  static init() {
    this.imagesAnimation();
  }

  static imagesAnimation() {
    const root = document.querySelector(".block-text_intro_home");
    if (!root) return;
    const images = [];
    root.querySelectorAll(".medias img").forEach((image) => {
      images.push(image.getAttribute("src"));
    });
    if (images.length === 0) return;

    let incr = 0,
      oldIncrX = 0,
      oldIncrY = 0,
      resetDist = window.innerWidth / 6;

    // Stocker indexImg comme propriété de l'instance pour qu'il persiste
    this.indexImg = 0;

    root.addEventListener(
      "mousemove",
      (e) => {
        oldIncrX = e.clientX;
        oldIncrY = e.clientY;
      },
      { once: true }
    );

    root.addEventListener("mousemove", (e) => {
      const valX = e.clientX;
      const valY = e.clientY;

      // Add the distance traveled on x + y
      incr += Math.abs(valX - oldIncrX) + Math.abs(valY - oldIncrY);

      if (incr > resetDist) {
        incr = 0; // Reset the variable incr

        // Calculer la position relative au root
        const rootRect = root.getBoundingClientRect();
        const x = valX - rootRect.left;
        const y = valY - rootRect.top;

        this.createMedia(x, y, valX - oldIncrX, valY - oldIncrY, images, root);
      }

      // Reset after calculation to add the new delta on the next call
      // Also reset after the createMedia() function
      oldIncrX = valX;
      oldIncrY = valY;
    });
  }

  static createMedia(x, y, deltaX, deltaY, images, root) {
    // We create an image and set its url with the current item of the images array
    const image = document.createElement("img");
    image.setAttribute("src", images[this.indexImg]);

    // Ajouter des styles pour éviter l'overflow et positionner correctement
    image.style.position = "absolute";
    image.style.pointerEvents = "none";
    image.style.zIndex = "10";
    image.style.transformOrigin = "center center";

    // We add this image to the DOM
    root.appendChild(image);

    const tl = gsap.timeline({
      onComplete: () => {
        // when our timeline is finished, we remove our image from the DOM
        root.removeChild(image);
        tl && tl.kill();
      },
    });

    tl.fromTo(
      image,
      {
        // Positionner l'image exactement au centre du curseur
        left: x,
        top: y,
        xPercent: -50,
        yPercent: -50,
        scaleX: 1.3,
        scaleY: 1.3,
        rotation: (Math.random() - 0.5) * 20,
      },
      {
        scaleX: 1,
        scaleY: 1,
        ease: "elastic.out(2, 0.6)", // Easing property responsible of the rebound effect
        duration: 0.6,
      }
    );

    tl.to(
      image,
      {
        // We add deltaX and deltaY for movement
        left: "+=" + deltaX * 4,
        top: "+=" + deltaY * 4,
        rotation: (Math.random() - 0.5) * 20,
        ease: "power4.out",
        duration: 1.5,
      },
      0
    ); // Démarre en même temps que l'animation précédente

    tl.to(image, {
      duration: 0.3,
      scale: 0.5, // Reduce the image later
      delay: 0.1,
      ease: "back.in(1.5)",
    });

    // Loop back to the first item when we're out of range in our images array
    this.indexImg = (this.indexImg + 1) % images.length;
  }
}
